<template>
    <v-app>
        <portal-sysbar></portal-sysbar>
        <div class="main-content">
            <portal-aside></portal-aside>
            <portal-title
            :title="$t('message.aside.krefeldplan', { value: 'default' })"
            ></portal-title>
            <portal-breadcumb></portal-breadcumb>

            <div class="content">
                <img class="plan" id="photoreplaced" src="@/assets/krefeldplan.jpg" alt="" title="">
                <div class ="infos">
                    <div class ="contact">
                        Bereitstellungsplan HBF Krefeld den <v-text-field outlined dense color="#00475A" v-model="datemaj" readonly></v-text-field>
                    </div>
                    <div class ="contact">
                        Stand: <v-text-field outlined dense color="#00475A" v-model="hmaj" style="flex: 0 0 65px;" readonly></v-text-field>Uhr
                    </div>
                    <div class ="contact" style="margin-top: 15px;">Ab 22:00 Uhr keine Bereitstellungen mehr !</div>
                </div>
                
                <v-row>
                    <!--Gleis 32 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 45px; top: 125px;">
                        <v-text-field outlined dense color="#00475A" v-model="g32s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 32 slot 2-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 100px; top: 125px;">
                         <v-text-field outlined dense color="#00475A" v-model="g32s2" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 32 slot 3-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 155px; top: 125px;">
                         <v-text-field outlined dense color="#00475A" v-model="g32s3" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                     <!--Gleis 32 slot 4-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 210px; top: 125px;">
                        <v-text-field outlined dense color="#00475A" v-model="g32s4" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 32 slot 5-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 265px; top: 125px;">
                        &nbsp;<v-text-field outlined dense color="#00475A" v-model="g32s5" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 32 slot 6-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 320px; top: 125px;">
                       <v-text-field outlined dense color="#00475A" v-model="g32s6" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 32 slot 7-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 375px; top: 125px;">
                        <v-text-field outlined dense color="#00475A" v-model="g32s7" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 32 slot 8-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 435px; top: 125px;">
                        <v-text-field outlined dense color="#00475A" v-model="g32s8" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <!--Gleis 31 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 380px; top: 155px;">
                        <v-text-field outlined dense color="#00475A" v-model="g31s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 31 slot 2-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 435px; top: 155px;">
                        <v-text-field outlined dense color="#00475A" v-model="g31s2" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <!--Gleis 92 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 665px; top: 155px;">
                        <v-text-field outlined dense color="#00475A" v-model="g92s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <!--Gleis 6 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 125px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g6s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 6 slot 2-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 185px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g6s2" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 6 slot 3-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 240px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g6s3" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 6 slot 4-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 295px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g6s4" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 6 slot 5-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 350px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g6s5" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 6 slot 6-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 405px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g6s6" :disabled="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <!--Gleis 25 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 605px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g25s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 25 slot 2-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 660px; top: 282px;">
                        <v-text-field outlined dense color="#00475A" v-model="g25s2" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <!--Gleis 7 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 125px; top: 310px;">
                        <v-text-field outlined dense color="#00475A" v-model="g7s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 7 slot 2-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 185px; top: 310px;">
                        <v-text-field outlined dense color="#00475A" v-model="g7s2" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 7 slot 3-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 240px; top: 310px;">
                        <v-text-field outlined dense color="#00475A" v-model="g7s3" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 7 slot 4-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 295px; top: 310px;">
                        <v-text-field outlined dense color="#00475A" v-model="g7s4" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 7 slot 5-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 350px; top: 310px;">
                        <v-text-field outlined dense color="#00475A" v-model="g7s5" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 7 slot 6-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 405px; top: 310px;">
                        <v-text-field outlined dense color="#00475A" v-model="g7s6" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>                
                <v-row>
                    <!--Gleis 8 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 125px; top: 340px;">
                        <v-text-field outlined dense color="#00475A" v-model="g8s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 8 slot 2-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 185px; top: 340px;">
                        <v-text-field outlined dense color="#00475A" v-model="g8s2" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 8 slot 3-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 240px; top: 340px;">
                        <v-text-field outlined dense color="#00475A" v-model="g8s3" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 8 slot 4-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 295px; top: 340px;">
                        <v-text-field outlined dense color="#00475A" v-model="g8s4" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 8 slot 5-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 350px; top: 340px;">
                        <v-text-field outlined dense color="#00475A" v-model="g8s5" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 8 slot 6-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 405px; top: 340px;">
                        <v-text-field outlined dense color="#00475A" v-model="g8s6" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>                    
                <v-row>
                    <!--Gleis 11 slot 1-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 185px; top: 390px;">
                        <v-text-field outlined dense color="#00475A" v-model="g11s1" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 11 slot 2-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 240px; top: 390px;">
                       <v-text-field outlined dense color="#00475A" v-model="g11s2" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 11 slot 3-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 295px; top: 390px;">
                        <v-text-field outlined dense color="#00475A" v-model="g11s3" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                    <!--Gleis 11 slot 4-->
                    <v-col class="d-flex slot" cols="12" sm="3" style="left: 350px; top: 390px;">
                        <v-text-field outlined dense color="#00475A" v-model="g11s4" :readonly="auth.disableInput"></v-text-field>
                    </v-col>
                </v-row>
                <v-row style="position: absolute; top: 430px;">
                    <div>
                        Es sind Bereitstellungen auf Gleis 32 (Puffer an Puffer) anzuwenden(Puffer an Puffer). Ein Freirangieren wird nur noch per Bestellung ausgeführt.
                    </div>
                </v-row>     
                <v-row style="position: absolute; top: 475px;">
                    <div class ="contact" >
                        Bestellung an :&nbsp; <v-text-field outlined dense color="#00475A" v-model="email" :readonly="auth.disableInput"></v-text-field>
                        Rufbereitschaft :&nbsp; <v-text-field outlined dense color="#00475A" v-model="phone" :readonly="auth.disableInput"></v-text-field>
                    </div>
                </v-row>

                <v-row class="button mt-10">
                    <v-col class="d-flex" cols="12" sm="2">
                        <div class="pt-4">
                            <v-btn @click="displayDocuments()" color="#00475A" block dark type="submit">
                                Zugang zu Dokumenten
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="2" v-if="auth.krefeldplan">
                        <div class="pt-4">
                            <v-btn @click="updatePlan()" color="#00475A" block dark type="submit">
                                Update PLAN
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            
            </div>
        </div>
    </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import TeamService from "@/services/TeamsService";
import {
  formatDate,
  formatDateHour,
  parseDatetimelocal,
} from "@/shared/DateHelper";
import { mapGetters } from "vuex";
export default {
    name: "LoginPage",
     data() {
        return {
            auth: {
                krefelplan: false,
                disableInput: true
            },
            g32s1: "",
            g32s2: "",
            g32s3: "",
            g32s4: "",
            g32s5: "",
            g32s6: "",
            g32s7: "",
            g32s8: "",
            g31s1: "",
            g31s2: "",
            g92s1: "",
            g6s1: "",
            g6s2: "",
            g6s3: "",
            g6s4: "",
            g6s5: "",
            g6s6: "",
            g25s1: "",
            g25s2: "",
            g7s1: "",
            g7s2: "",
            g7s3: "",
            g7s4: "",
            g7s5: "",
            g7s6: "",
            g8s1: "",
            g8s2: "",
            g8s3: "",
            g8s4: "",
            g8s5: "",
            g8s6: "",
            g11s1: "",
            g11s2: "",
            g11s3: "",
            g11s4: "",
            email: "",
            phone: "",
            datemaj: "",
            hmaj: ""
        };
    },

    mounted() {
        this.isAuthorized();
        this.getLastPlan();
    },

    computed: {
    ...mapGetters("auth", {
      getterFunctionnalities: "getFunctionnalities",
    }),
  },


    methods: {
        isAuthorized() {
            if (this.getterFunctionnalities.includes("krefeldadmin")) {
                this.auth = {
                    krefeldplan: true
                };
            }
        },

        async updatePlan() {
            let payload = {
                g32s1: this.g32s1,
                g32s2: this.g32s2,
                g32s3: this.g32s3,
                g32s4: this.g32s4,
                g32s5: this.g32s5,
                g32s6: this.g32s6,
                g32s7: this.g32s7,
                g32s8: this.g32s8,
                g31s1: this.g31s1,
                g31s2: this.g31s2,
                g92s1: this.g92s1,
                g6s1: this.g6s1,
                g6s2: this.g6s2,
                g6s3: this.g6s3,
                g6s4: this.g6s4,
                g6s5: this.g6s5,
                g6s6: this.g6s6,
                g25s1: this.g25s1,
                g25s2: this.g25s2,
                g7s1: this.g7s1,
                g7s2: this.g7s2,
                g7s3: this.g7s3,
                g7s4: this.g7s4,
                g7s5: this.g7s5,
                g7s6: this.g7s6,
                g8s1: this.g8s1,
                g8s2: this.g8s2,
                g8s3: this.g8s3,
                g8s4: this.g8s4,
                g8s5: this.g8s5,
                g8s6: this.g8s6,
                g11s1: this.g11s1,
                g11s2: this.g11s2,
                g11s3: this.g11s3,
                g11s4: this.g11s4,
                email: this.email,
                phone: this.phone,
            };
            await TeamService.updatePlanKrefeld(payload);
            this.getLastPlan();
        },

        displayDocuments() {
            this.$router.push("/krefelddocuments");
        },

        getLastPlan(){
            TeamService.findLastPlan().then((response) => {
                if (response.data.length != 0) {
                    this.g32s1 = response.data.g32s1;
                    this.g32s2 = response.data.g32s2;
                    this.g32s3 = response.data.g32s3;
                    this.g32s4 = response.data.g32s4;
                    this.g32s5 = response.data.g32s5;
                    this.g32s6 = response.data.g32s6;
                    this.g32s7 = response.data.g32s7;
                    this.g32s8 = response.data.g32s8;
                    this.g31s1 = response.data.g31s1;
                    this.g31s2 = response.data.g31s2;
                    this.g92s1 = response.data.g92s1;
                    this.g6s1 = response.data.g6s1;
                    this.g6s2 = response.data.g6s2;
                    this.g6s3 = response.data.g6s3;
                    this.g6s4 = response.data.g6s4;
                    this.g6s5 = response.data.g6s5;
                    this.g6s6 = response.data.g6s6;
                    this.g25s1 = response.data.g25s1;
                    this.g25s2 = response.data.g25s2;
                    this.g7s1 = response.data.g7s1;
                    this.g7s2 = response.data.g7s2;
                    this.g7s3 = response.data.g7s3;
                    this.g7s4 = response.data.g7s4;
                    this.g7s5 = response.data.g7s5;
                    this.g7s6 = response.data.g7s6;
                    this.g8s1 = response.data.g8s1;
                    this.g8s2 = response.data.g8s2;
                    this.g8s3 = response.data.g8s3;
                    this.g8s4 = response.data.g8s4;
                    this.g8s5 = response.data.g8s5;
                    this.g8s6 = response.data.g8s6;
                    this.g11s1 = response.data.g11s1;
                    this.g11s2 = response.data.g11s2;
                    this.g11s3 = response.data.g11s3;
                    this.g11s4 = response.data.g11s4;
                    this.email = response.data.email;
                    this.phone = response.data.phone;

                    let date  = parseDatetimelocal(response.data.updatedAt);
                    this.datemaj = formatDate(date);
                    this.hmaj = formatDateHour(date);
                }
            });
        },
    },
    
    components: {
        PortalSysbar,
        PortalAside,
        PortalTitle,
        PortalBreadcumb,

    },
};

</script>
<style scoped>

.content {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}

.plan {
    left: 3px;
    top: 2px;
    position: absolute;
    width: 757px;
    height: 535px;
}
:deep( .v-text-field--outlined) {
    font-size: 10px;
}
:deep( .v-text-field--outlined fieldset) {
    border-style: none !important;
}
.contact {
    display: flex !important;
    justify-content: flex-start;
    align-items: baseline;
    flex-wrap: wrap;
    width: 850px;
}
.contact .v-text-field--outlined{
    font-size: 16px !important;
}

.slot {
    position: absolute;
    width: 90px;
}

.infos {
    position: absolute; 
    left: 10%; 
    top: 25px;
}

.infos > div {
    height: 30px;
}

:deep( .infos .v-text-field input) {
    color: #00475a !important;
}

.button{
    position: absolute;
    width: 850px;
    top: 500px;
    display: flex;
    justify-content: space-between;
}
</style>
